import { ProcessStep } from "../types";
import { NO_OPTIMIZED_MACHINE_TIMES } from "./computeOptimizedMachineTimes";
import { computeProcessPrice } from "./computeProcessPrice";

type Params = {
  processStep: ProcessStep;
};

export const computeQuoteRequestProcessPrice = ({ processStep }: Params) => {
  return computeProcessPrice({
    quantity: 1,
    quantityInAssembly: null,
    reworkRatio: null,
    processStep: {
      ...processStep,
      materialLayout: null,
      productLines: [],
    },
    optimizedMachineTimes: NO_OPTIMIZED_MACHINE_TIMES,
  });
};
